import { type SVGProps, type Ref, forwardRef, useId } from 'react'

export const Avatar = forwardRef(
  (
    { className, ...props }: SVGProps<SVGSVGElement>,
    ref: Ref<SVGSVGElement>
  ) => {
    const filter0 = useId()
    const filter1 = useId()
    const filter2 = useId()
    const filter3 = useId()
    const paint0 = useId()

    return (
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        className={className}
        {...props}
      >
        <g opacity="0.64">
          <g filter={`url(#${filter0})`}>
            <path
              d="M25.3125 29.25C11.8125 29.25 -10.125 1.3125 -9 -8.4375L77.9548 -12.375C86.5798 -4.5 98.6548 16.875 77.9548 39.375C52.0798 67.5 42.1875 29.25 25.3125 29.25Z"
              fill={`url(#${paint0})`}
            />
          </g>
          <g opacity="0.3" filter={`url(#${filter1})`}>
            <path
              d="M-20.0145 26.2787C-33.4225 26.2787 -34.5398 4.31159 -33.4225 -6.67199L29.1483 -12.375C37.7146 -3.50365 49.7073 20.5757 29.1483 45.9224C3.44965 77.6058 -3.25444 26.2787 -20.0145 26.2787Z"
              fill="currentColor"
            />
            <path
              d="M-20.0145 26.2787C-33.4225 26.2787 -34.5398 4.31159 -33.4225 -6.67199L29.1483 -12.375C37.7146 -3.50365 49.7073 20.5757 29.1483 45.9224C3.44965 77.6058 -3.25444 26.2787 -20.0145 26.2787Z"
              stroke="currentColor"
              strokeWidth="1.125"
            />
          </g>
          <g opacity="0.3" filter={`url(#${filter2})`}>
            <path
              d="M50.836 89.5951C58.6173 94.0876 51.9053 107.21 47.5767 113.21L9.35333 95.555C7.35442 87.5363 8.4626 69.5437 28.8866 61.7224C54.4165 51.9458 41.1094 83.9794 50.836 89.5951Z"
              fill="currentColor"
            />
            <path
              d="M50.836 89.5951C58.6173 94.0876 51.9053 107.21 47.5767 113.21L9.35333 95.555C7.35442 87.5363 8.4626 69.5437 28.8866 61.7224C54.4165 51.9458 41.1094 83.9794 50.836 89.5951Z"
              stroke="currentColor"
              strokeWidth="1.125"
            />
          </g>
          <g opacity="0.6" filter={`url(#${filter3})`}>
            <path
              d="M54.8265 53.3937C48.5288 53.3937 48.004 42.2301 48.5288 36.6483L77.9182 33.75C81.9417 38.2584 87.5746 50.4955 77.9182 63.3766C65.8476 79.478 62.6987 53.3937 54.8265 53.3937Z"
              fill="currentColor"
            />
            <path
              d="M54.8265 53.3937C48.5288 53.3937 48.004 42.2301 48.5288 36.6483L77.9182 33.75C81.9417 38.2584 87.5746 50.4955 77.9182 63.3766C65.8476 79.478 62.6987 53.3937 54.8265 53.3937Z"
              stroke="currentColor"
              strokeWidth="1.125"
            />
          </g>
        </g>
        <defs>
          <filter
            id={filter0}
            x="-20.8542"
            y="-24.1875"
            width="122.051"
            height="85.6995"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="5.90625"
              result="effect1_foregroundBlur_2278_11875"
            />
          </filter>
          <filter
            id={filter1}
            x="-49.1625"
            y="-27.8096"
            width="105.075"
            height="99.4723"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7.425"
              result="effect1_foregroundBlur_2278_11875"
            />
          </filter>
          <filter
            id={filter2}
            x="-6.75723"
            y="44.4668"
            width="76.5809"
            height="84.2986"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7.425"
              result="effect1_foregroundBlur_2278_11875"
            />
          </filter>
          <filter
            id={filter3}
            x="32.9625"
            y="18.3122"
            width="65.7012"
            height="65.7255"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="7.425"
              result="effect1_foregroundBlur_2278_11875"
            />
          </filter>
          <linearGradient
            id={paint0}
            x1="48.9375"
            y1="19.125"
            x2="20.25"
            y2="57.9375"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="currentColor" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0.44" />
          </linearGradient>
        </defs>
      </svg>
    )
  }
)

Avatar.displayName = 'SliderEmptyState'
